import sendIcon from "../../src/img/send-icon.svg";
import { Skeleton, Button, Checkbox } from "@mui/material";

export default function EditAccountsModalSkeleton() {

  return (
    <div>
      <div className="title-id">
        <h4 style={{ fontWeight: "600", color: "var(--orange)", margin: "0" }}>
          Edit Account
        </h4>
        <div style={{ display: 'flex', flexDirection: 'row' }} >
          <p style={{ font: "var(--p2)", margin: "0" }}>Account ID:</p>
          <Skeleton variant="rectangular" width={25} height={20} />
        </div>
      </div>

      <div className="row-modal">
        <div className="column-modal">
          <div className="input-column">
            <label>First Name</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Last Name</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Email</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Screen Name</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Discord Tag</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

        </div>

        {/* ------------------------------ */}

        <div className="column-modal">
          <div className="input-column">
            <label>Change Password</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Confirm Password</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Address 1</label>
            <Skeleton variant="rectangular" width={195} height={32} />

            <div className="input-column">
              <label>Address 2</label>
              <Skeleton variant="rectangular" width={195} height={32} />
            </div>
          </div>

          <div className="input-column">
            <label>PayPal Email</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

        </div>

        {/* ------------------------------ */}

        <div className="column-modal">
          <div className="input-column">
            <label>City</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>State</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>ZIP</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="input-column">
            <label>Mobile Phone</label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>
        </div>

        {/* ------------------------------ */}

        <div className="column-modal" style={{ width: "fit-content", margin: "0" }} >
          <div className="input-column">
            <label>
              <h4 style={{ color: "var(--orange)" }}>Status Account</h4>
            </label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <Button
            variant="outlined"
            style={{ margin: "0 0 1em 0" }}
          >
            Send Email Verification
            <img
              src={sendIcon}
              alt="send icon"
              height="18px"
              width="18px"
              style={{ margin: "0 0 0 0.5em" }}
            />
          </Button>

          <div className="input-column">
            <label>
              <h4 style={{ color: "var(--orange)" }}> User Type</h4>
            </label>
            <Skeleton variant="rectangular" width={195} height={32} />
          </div>

          <div className="checkbox-200px" style={{ margin: "0" }}>
            <Checkbox />
            <label htmlFor="userDistribution">
              <p>User is eligible for distribution</p>
            </label>
          </div>
          <div className="checkbox-200px" style={{ margin: "0" }}>
            <Checkbox />
            <label htmlFor="useSwarm">
              <p>User is eligible for Swarms</p>
            </label>
          </div>
          <div className="checkbox-200px">
            <Checkbox />
            <label htmlFor="systemAdmin">
              <p>Do Not Drone Buy</p>
            </label>
          </div>
          <div className="checkbox-200px">
            <Checkbox />
            <label htmlFor="systemAdmin">
              <p>System Admin</p>
            </label>
          </div>
        </div>

      </div>

      {/* ------------------------------------------------------------------ */}

      <div
        className="modal-buttons"
        style={{ justifyContent: "space-between" }}
      >
        <Button
          variant="outlined"
          style={{
            color: "var(--red)",
            background: "white",
            borderColor: "var(--red)",
            whiteSpace: "nowrap",
          }}
        >
          Delete User
        </Button>

        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }} >
          <Button
            variant="contained"
            color="secondary"
            style={{ margin: "0 2em 0 0", width: "100px" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{ width: "100px" }}
          >
            Save
          </Button>
        </div>
      </div>

      <div className="modal-footer">
        <p style={{ color: "var(--grey-inactive)", margin: "0 0.5em 0 0" }}>
          Created{" "}
        </p>{" "}
        <Skeleton variant="rectangular" width={114} height={16} sx={{margin: "0 0.5em 0 0"}} />
        <p style={{ color: "var(--grey-inactive)", margin: "0 0.5em 0 0" }}>
          Modified on{" "}
        </p>{" "}
        <Skeleton variant="rectangular" width={114} height={16} />
      </div>

    </div>
    
  )
}